const HIDDEN_KEY_STORAGE = 'bombeo.hiddenKey'

const sha256Hex = async (text: string): Promise<string> => {
  const digest = await crypto.subtle.digest('SHA-256', new TextEncoder().encode(text))
  return [...new Uint8Array(digest)].map(byte => byte.toString(16).padStart(2, '0')).join('')
}

export const isHiddenKey = async (key: string, expectedSha256: string | undefined): Promise<boolean> =>
  !!expectedSha256 && key !== '' && (await sha256Hex(key)) === expectedSha256.trim().toLowerCase()

export const readHiddenKey = (): string | null => {
  try {
    return localStorage.getItem(HIDDEN_KEY_STORAGE)
  } catch {
    return null
  }
}

export const storeHiddenKey = (key: string): boolean => {
  try {
    localStorage.setItem(HIDDEN_KEY_STORAGE, key)
    return true
  } catch {
    return false
  }
}
